// Global Instructions Rule Applied!

import {
  fetchContactById,
  createContact,
  updateContact
} from '../../../app_modules/contacts/services/contactsService.ts'
import { updateContactRecord, addContact } from './contact_actions.ts'
import { ContactRecord } from '../../data_models/contact_record.ts'
import { AppDispatch } from '../../store.ts'

/**Fetches a contact by ID. */
const fetchContactByIdService = async (
  contactId: string | number,
  accessToken: string | null,
  dispatch: AppDispatch
): Promise<{ data: ContactRecord | null; error?: string }> => {
  try {
    const response = await fetchContactById(contactId, accessToken)

    if (response.error) {
      return { data: null, error: response.error }
    }

    return { data: response.data as ContactRecord | null }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to fetch contact'
    return { data: null, error: errorMessage }
  }
}

/**Creates a new contact and dispatches addContact action. */
export const createContactService = async (
  contactData: Record<string, any>,
  accessToken: string | null,
  dispatch: AppDispatch
): Promise<{ data: ContactRecord | null; error?: string }> => {
  try {
    const response = await createContact(contactData, accessToken)

    if (response.error) {
      return { data: null, error: response.error }
    }

    if (response.data) {
      dispatch(addContact({ contact: response.data as ContactRecord }))
    }

    return { data: response.data as ContactRecord | null }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to create contact'
    return { data: null, error: errorMessage }
  }
}

/**Updates an existing contact and dispatches updateContactRecord action. */
export const updateContactService = async (
  contactId: string | number,
  contactData: Record<string, any>,
  accessToken: string | null,
  dispatch: AppDispatch
): Promise<{ data: ContactRecord | null; error?: string }> => {
  try {
    const response = await updateContact(contactId, contactData, accessToken)

    if (response.error) {
      return { data: null, error: response.error }
    }

    if (response.data) {
      const updatedContact = response.data as ContactRecord
      const idString = contactId.toString()

      dispatch(
        updateContactRecord({
          contactId: idString,
          updates: updatedContact
        })
      )
    }

    return { data: response.data as ContactRecord | null }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Failed to update contact'
    return { data: null, error: errorMessage }
  }
}
